import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../interceptors/axios";

export const getPlans = createAsyncThunk("getPlans", async () => {
  try {
    const {
      data: { data },
    } = await api.get("/api/v3/plans", { params: { sort: "order" } });

    return data.map((plan) => ({
      id: plan._id,
      name: plan.name,
      description: plan.description,
      price: plan.price,
      stripe: plan.stripe,
      paypalPlanId: plan.paypalPlanId,
      pricePerWeek: plan.pricePerWeek,
      label: plan.label,
      cycle: plan.cycle,
    }));
  } catch (error) {
    console.error("Error getting PayPal plans:", error);
  }
});

export const getPlanById = async (id) => {
  const {
    data: { data },
  } = await api.get(`/api/v3/plans/${id}`);

  return data;
};

export const validateSubscription = async (subscriptionId, method) => {
  try {
    const {
      data: { data },
    } = await api.post("/api/v3/web-subscriptions", {
      subscriptionId,
      method,
    });

    return data;
  } catch (error) {
    console.error("Error get subscription by ID:", error);
    throw error;
  }
};

export const checkSubscriptionStatus = createAsyncThunk(
  "checkSubscription",
  async () => {
    try {
      const {
        data: { data },
      } = await api.get("/api/v3/web-subscriptions/status");

      return data;
    } catch (error) {
      console.error("Error check subscription status:", error);
      throw error;
    }
  }
);

export const changePlanOfSubscription = async (subscriptionId, newPlanId) => {
  try {
    const {
      data: { data },
    } = await api.put("/api/v3/web-subscriptions", {
      subscriptionId,
      planId: newPlanId,
    });

    return data;
  } catch (error) {
    console.error("Error change plan of subscription", error);
    throw error;
  }
};

export const cancelSubscriptionById = async (subscriptionId) => {
  try {
    const {
      data: { data },
    } = await api.post("/api/v3/web-subscriptions/cancel", {
      subscriptionId,
    });

    return data;
  } catch (error) {
    console.error("Error cancel subscription:", error);
    throw error;
  }
};
